import React from 'react';
import { Shuffle, Code, Share2, Plus, Minus } from '../../components/icons';
import type { HarmonyMode } from '../../utils/studioPalette';
import { HARMONY_LABELS } from '../../utils/studioPalette';

interface StudioToolbarProps {
  harmonyMode: HarmonyMode;
  colorCount: number;
  onGenerate: () => void;
  onHarmonyChange: (mode: HarmonyMode) => void;
  onCountChange: (delta: number) => void;
  onExport: () => void;
  onShare: () => void;
}

const HARMONY_MODES = Object.keys(HARMONY_LABELS) as HarmonyMode[];

const StudioToolbar: React.FC<StudioToolbarProps> = ({
  harmonyMode,
  colorCount,
  onGenerate,
  onHarmonyChange,
  onCountChange,
  onExport,
  onShare,
}) => (
  <div className="flex flex-wrap items-center gap-3 border-y border-surface-border bg-white px-4 py-3 sm:px-6 lg:px-8">
    {/* Generate */}
    <button
      onClick={onGenerate}
      className="ui-button-primary"
    >
      <Shuffle size={18} aria-hidden="true" />
      Generate
    </button>

    {/* Harmony dropdown */}
    <select
      value={harmonyMode}
      onChange={e => onHarmonyChange(e.target.value as HarmonyMode)}
      aria-label="Palette harmony"
      className="ui-input max-w-full"
    >
      {HARMONY_MODES.map(mode => (
        <option key={mode} value={mode}>{HARMONY_LABELS[mode]}</option>
      ))}
    </select>

    {/* Color count */}
    <div className="flex items-center rounded-control border border-surface-border-strong">
      <button
        onClick={() => onCountChange(-1)}
        disabled={colorCount <= 3}
        className="ui-icon-button"
        aria-label="Remove color"
      >
        <Minus size={18} aria-hidden="true" />
      </button>
      <span className="text-sm font-mono text-ink-secondary w-6 text-center">{colorCount}</span>
      <button
        onClick={() => onCountChange(1)}
        disabled={colorCount >= 8}
        className="ui-icon-button"
        aria-label="Add color"
      >
        <Plus size={18} aria-hidden="true" />
      </button>
    </div>

    {/* Spacer */}
    <div className="flex-1" />

    {/* Keyboard hint */}
    <span className="hidden xl:block text-xs text-ink-muted">
      Space = generate &middot; L = lock &middot; &larr;&rarr; = navigate
    </span>

    {/* Export */}
    <button
      onClick={onExport}
      className="ui-button-secondary"
    >
      <Code size={18} aria-hidden="true" />
      Export
    </button>

    {/* Share */}
    <button
      onClick={onShare}
      className="ui-button-secondary"
    >
      <Share2 size={18} aria-hidden="true" />
      Share
    </button>
  </div>
);

export default StudioToolbar;
